import Dexie from 'dexie';

const DATABASE_VERSION = 28;
export const db = new Dexie('backoffice');
db.version(DATABASE_VERSION).stores({
	// Tables from MySQL schema
	techyshop_attributi: 'id, nome, tipo',
	techyshop_attributo_valori: 'id, attributo_id, valore',
	techyshop_banner: 'id, titolo, posizione, attivo',
	techyshop_categorie: 'id, nome, slug, categoria_padre_id, visibile',
	techyshop_impostazioni: 'id, chiave',
	techyshop_medias: 'id, tabella, element_id, principale',
	techyshop_menu: 'id, nome, posizione, enable',
	techyshop_pagine: 'id, titolo, slug, visibile',
	techyshop_prodotti: 'id, sku, nome, slug, prezzo, visibile, in_evidenza',
	techyshop_prodotto_attributo: 'id, prodotto_id, prodotto_variante_id, attributo_id, attributo_valore_id',
	techyshop_prodotto_categoria: '[prodotto_id+categoria_id], prodotto_id, categoria_id',
	techyshop_prodotto_varianti: 'id, prodotto_id, visibile, default',
	techyshop_recensioni: 'id, prodotto_id, approvata',
	techyshop_utente_carrello: 'id, utente_id, prodotto_id',
	techyshop_utente_indirizzi: 'id, predefinito',
	techyshop_utente_sessioni: 'id, utente_id, auth',
	techyshop_utenti: 'id, email, nome, cognome, attivo', // Left as is for now
	techyshop_voci_menu: 'id, menu_id, voce_padre_id, visibile',
	techyshop_wishlist: 'id, utente_id, prodotto_id',

	// Other application tables
	genericTable: '[table+field], value, date',
	logs: '++id, timestamp, type',
	users: '++id, user, username, auth',
	strings: '[string+language], user, bot',
	telegramMessages: 'message, telegram_message_id, user, chat, bot, date',
	docalls: 'docall, REMOTE_ADDR, SERVER_NAME, date'
});
